export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  isAdding: (state) => state.isAdding,
  effects: (state) => state.effects,
  sar: (state) => state.sar,
  types: (state) => state.types,
  users: (state) => state.users,
  paging: (state) => state.paging,
  counterParties: (state) => {
    if (!state.sar?.user.id) {
      return [];
    }
    return state.users.filter((user) => user.id !== state.sar.user.id);
  },
  nextPage: (state) => (state.paging ? state.paging.next_page : 0),
};
